import { render, staticRenderFns } from "./ModalImportacaoCatalogoItens.vue?vue&type=template&id=6e6d905f&scoped=true"
import script from "./ModalImportacaoCatalogoItens.vue?vue&type=script&lang=js"
export * from "./ModalImportacaoCatalogoItens.vue?vue&type=script&lang=js"
import style0 from "./ModalImportacaoCatalogoItens.vue?vue&type=style&index=0&id=6e6d905f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6d905f",
  null
  
)

export default component.exports